import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import strings from '../../locale/en'
import {
  getAllCoursesByInstitute,
  getChildCourses,
  getChildByInstitute,
  getMaterialByTopic,
  getCourses,
  getAllCourses,
  getCourse,
  deleteCourse,
  saveCourse,
  editCourse
} from './api'
import {
  Course,
  GetChildCoursesResponse,
  InitialState,
  GetMaterialByTopicResponse,
  GetCoursesResponse,
  GetAllCoursesResponse,
  CourseDetails,
  CourseResponse
} from './types'

const initialState: InitialState = {
  isLoading: false,
  courses: [],
  courseDetails: [],
  pageSize: 1,
  currentPage: 0,
  subjects: [],
  chapters: [],
  topics: [],
  materials: [],
  error: '',
  coursesToAddMaterial: [],
  selectedCourse: null
}

export const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    resetCourses: (state) => {
      state.courses = []
    },
    resetSubjects: (state) => {
      state.subjects = []
    },
    resetChapters: (state) => {
      state.chapters = []
    },
    resetTopics: (state) => {
      state.topics = []
    },
    resetError: (state) => {
      state.error = ''
    },
    setSelectedCourse: (state, action: PayloadAction<Course>) => {
      state.selectedCourse = action.payload
    },
    resetSelectedCourse: (state) => {
      state.selectedCourse = null
    }
  },
  extraReducers: {
    [getAllCoursesByInstitute.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getAllCoursesByInstitute.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Course>>
    ) => {
      state.isLoading = false
      state.courses = action?.payload
    },
    [getChildByInstitute.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Course>>
    ) => {
      state.courses = action?.payload
    },
    [getAllCoursesByInstitute.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getChildCourses.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getChildCourses.fulfilled.toString()]: (
      state,
      action: PayloadAction<GetChildCoursesResponse>
    ) => {
      state.isLoading = false
      const { response, type } = action?.payload
      switch (type) {
        case 'SUBJECT':
          state.subjects = response
          break
        case 'CHAPTER':
          state.chapters = response
          break
        default:
          state.topics = response
          break
      }
    },
    [getChildCourses.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getMaterialByTopic.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getMaterialByTopic.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getMaterialByTopic.fulfilled.toString()]: (
      state,
      action: PayloadAction<GetMaterialByTopicResponse>
    ) => {
      state.isLoading = false
      state.materials = action.payload?.materials
    },
    [getCourses.fulfilled.toString()]: (
      state,
      action: PayloadAction<GetCoursesResponse>
    ) => {
      state.coursesToAddMaterial = action.payload?.coursesToAddMaterial
    },
    [getAllCourses.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getAllCourses.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getAllCourses.fulfilled.toString()]: (
      state,
      action: PayloadAction<GetAllCoursesResponse>
    ) => {
      state.isLoading = false
      state.courses = action?.payload?.courses
      state.pageSize = action?.payload?.pageSize
      state.currentPage = action?.payload?.currentPage
    },
    [getCourse.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getCourse.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getCourse.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<CourseDetails>>
    ) => {
      state.isLoading = false
      state.courseDetails = action?.payload
    },
    [deleteCourse.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [deleteCourse.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = strings.validationMessages.course.deleteCourseFailed
    },
    [deleteCourse.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [saveCourse.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [saveCourse.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = strings.validationMessages.course.saveError
    },
    [saveCourse.fulfilled.toString()]: (
      state,
      action: PayloadAction<CourseResponse>
    ) => {
      state.isLoading = false
      state.error = action.payload?.error || ''
    },
    [editCourse.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [editCourse.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = strings.validationMessages.course.saveError
    },
    [editCourse.fulfilled.toString()]: (
      state,
      action: PayloadAction<CourseResponse>
    ) => {
      state.isLoading = false
      state.error = action.payload?.error || ''
    }
  }
})

export default courseSlice.reducer
